import { createCrudSlice } from '@crm/features/crudSliceFactory';

const module = createCrudSlice({
  name: 'crmExpenditures',
  path: 'expenditures',
  singleKey: 'expenditure',
});

export const expendituresActions = module.actions;
export const expendituresThunks = module.thunks;
export const expendituresSelectors = module.selectors;
export default module.reducer;
